import React, {useState} from 'react';
import {Choice, FieldProp} from '../../types';
import {Select} from './Select';
import {DisplayOnly} from './DisplayOnly';

type MultiSelectProps = FieldProp & {};

export const MultiSelect: React.FunctionComponent<MultiSelectProps> = (props): JSX.Element => {
    const [inputValue, setInputValue] = useState<string>('');
    const {displayOnly, value} = props;
    return (
        displayOnly ?
            <DisplayOnly>{value?.map((item: Choice, index: number) => (
                <div key={index}>{item?.text}</div>
            ))}</DisplayOnly>
            :
            <Select
                {...props}
                isMulti={true}
                inputValue={inputValue}
                onInputChange={(inputValue: string, type: any) => {
                    if (type.action === 'input-change') {
                        if (inputValue.match(/ /)) {
                            const values = inputValue.split(' ');
                            const matchedChoices = props.field.choices.filter((choice: any) => values.includes(choice.value));
                            props.onChange([...value, ...matchedChoices]);
                            setInputValue('');
                            return;
                        }
                    }
                    setInputValue(inputValue);
                }}
            />
    );
};